export const predictiveSearchChosenSuggestion = (state) =>
  state.tracking.predictiveSearch.chosenSuggestion
export const predictiveSearchInput = (state) => {
  const chosenSuggestion = predictiveSearchChosenSuggestion(state)
  if (chosenSuggestion) {
    return chosenSuggestion.acFeedback
  }

  return undefined
}
export const predictiveSearchQ = (state) => {
  const chosenSuggestion = predictiveSearchChosenSuggestion(state)
  if (chosenSuggestion) {
    return chosenSuggestion.q
  }

  return undefined
}
export const predictiveSearchSuggestions = (state) => state.tracking.predictiveSearch.suggestions
